import { CreateRequestToPayMutation, GetRequestToPayQuery, RequestToPayByCustomerIDQuery, RequestToPayByOrderIDQuery, RequestToPayBySaleIDQuery, UpdateRequestToPayMutation } from "@/API";
import { IRequestToPay, IRequestToPayData, RequestToPay } from "@/entities/requestToPay";
import * as mutations from "@/graphql/mutations";
import * as queires from "@/graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { IRequestToPayRepository } from "./requestToPay.types";
import { nanoid } from 'nanoid'

export class RequestToPayAPIRepository implements IRequestToPayRepository {
    async get(id: string): Promise<IRequestToPay | undefined> {
        const result = (await API.graphql(
            graphqlOperation(queires.getRequestToPay, {
                id,
            })
        )) as any;

        console.log({result});

        const r = (result?.data as GetRequestToPayQuery).getRequestToPay;
        const rtp: any = r;

        if (r) {
            return new RequestToPay(rtp);
        }
        return;
    }

    async create(data: IRequestToPayData): Promise<IRequestToPay> {
        const id = nanoid(10);
        const result = (await API.graphql(
            graphqlOperation(mutations.createRequestToPay, {
                input: {
                    ...data,
                    id,
                },
            })
        )) as any;
        const r = (result?.data as CreateRequestToPayMutation).createRequestToPay;
        const rtp: any = r;
        return new RequestToPay(rtp as any);
    }

    async update(data: IRequestToPayData): Promise<IRequestToPay> {
        const result = (await API.graphql(
            graphqlOperation(mutations.updateRequestToPay, {
                input: data,
            })
        )) as any;
        const r = (result?.data as UpdateRequestToPayMutation).updateRequestToPay;
        const rtp: any = r;
        return new RequestToPay(rtp as any);
    }

    async delete(id: string): Promise<void> {
        await API.graphql(
            graphqlOperation(mutations.deleteRequestToPay, {
                id,
            })
        );
        return;
    }

    async listRequestToPayBySaleID(id: string, nextToken: string | null | undefined): Promise<RequestToPayBySaleIDQuery> {
        console.log(id, nextToken);
        const result = (await API.graphql(
            graphqlOperation(queires.requestToPayBySaleID, {
                saleID: id,
                limit: 30,
                sortDirection: "DESC",
                nextToken,
            })
        )) as any;
        return result.data;
    }

    async getRequestToPayByOrderID(orderID: string): Promise<IRequestToPay | undefined> 
    {
        const result = (await API.graphql(
            graphqlOperation(queires.requestToPayByOrderID, {
                orderID,
            })
        )) as any;

        console.log({result});

        const r = (result?.data as RequestToPayByOrderIDQuery).requestToPayByOrderID?.items;
        if(r){
            if(r?.length > 0){
                const rtp: any = r[0];
                return new RequestToPay(rtp);
            }
        }
        return;
    }

    async sendSMS(payload: any): Promise<void>
    {
        return API.post("saletoolapi","/sendSMS", {
            body: payload,
        });
    }

    async sendEmail(payload: any): Promise<void>
    {
        return API.post("saletoolapi","/sendEmail", {
            body: payload,
        });
    }
}
